export default class GreyCatLintError {
    constructor(message, range, severity = 'error') {
        this.message = message;
        this.range = range;
        this.severity = severity;
        this.name = 'GreyCatLintError';
    }
}
//# sourceMappingURL=lint-error.js.map